import { useMemo } from 'react'

import { SpacerRebrand } from 'src/config/generated/sanitySchema'

const SectionSpacerRebrand = ({ size }: SpacerRebrand) => {
  const spacing = useMemo(() => {
    switch (size) {
      case 'small':
        return 'h-2 md:h-4'
      case 'medium':
        return 'h-3 md:h-6'
      case 'large':
        return 'h-6 md:h-12'
      case 'xLarge':
        return 'h-10 md:h-20'
      default:
        return 'h-3 md:h-6'
    }
  }, [size])

  return <div className={`w-full ${spacing}`} />
}

export default SectionSpacerRebrand
